import type { ReactNode } from 'react';
import { PixelButton } from './PixelButton';

export function EmptyState({
  title,
  body,
  cta,
  onCta,
}: {
  title: string;
  body: ReactNode;
  cta?: ReactNode;
  onCta?: () => void;
}) {
  return (
    <div className="pixel-panel pixel-panel--parchment empty">
      <div className="empty__title">{title}</div>
      <div className="empty__body">{body}</div>
      {cta && onCta && (
        <PixelButton variant="gold" onClick={onCta}>
          {cta}
        </PixelButton>
      )}
    </div>
  );
}
